import type {
    AuthorizedMedicationInfoFragment,
    MedicationInfoFragment,
    UnknownMedicationInfoFragment,
} from '../../graphql/generated/graphql';
import type { MedicationConfigOverride } from '../../hooks/use-config-api';

export type PricingInfo = {
    type: string;
    price: number;
};

export const getPricing = (
    configOverride: MedicationConfigOverride,
    medication:
        | AuthorizedMedicationInfoFragment
        | MedicationInfoFragment
        | UnknownMedicationInfoFragment
): PricingInfo | undefined => {
    const ndc =
        medication.__typename === 'UnknownMedication'
            ? medication.originalNdc || medication.id
            : medication.id;
    return getPricingByNdc(configOverride, ndc);
};

export const getPricingByNdc = (
    configOverride: MedicationConfigOverride,
    medicationId: string
): PricingInfo | undefined => {
    // Check insurance pricing
    if (configOverride.staticPricing.insurance?.[medicationId]) {
        return {
            type: 'insurance',
            price: configOverride.staticPricing.insurance[medicationId],
        };
    }

    // Check self-pay pricing
    if (configOverride.staticPricing.selfPay?.[medicationId]) {
        return {
            type: 'selfPay',
            price: configOverride.staticPricing.selfPay[medicationId],
        };
    }

    return undefined;
};
